export default __webpack_public_path__ + "static/media/ic_bnb_96.5bc4fc2e.svg";